import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Mail, MessageCircle, Phone, MapPin } from 'lucide-react';

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-[#FCFAF8] flex flex-col">
      <Header />
      <main className="flex-1 max-w-3xl mx-auto px-4 sm:px-6 py-12">
        <span className="inline-block bg-[#FFF5F5] text-[#D48585] text-xs font-body font-semibold px-3 py-1 rounded-full mb-4">Get in Touch</span>
        <h1 className="font-heading text-3xl sm:text-4xl text-[#2C2A29] mb-6" data-testid="contact-title">Contact Us</h1>

        <div className="space-y-6">
          <div className="bg-white rounded-2xl p-6 border border-cream-100/50" data-testid="contact-email-card">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-full bg-[#FFF5F5] flex items-center justify-center flex-shrink-0">
                <Mail size={22} className="text-[#D48585]" />
              </div>
              <div>
                <h2 className="font-heading text-lg text-[#2C2A29] mb-1">Email</h2>
                <a href="mailto:hello@stashmart.store" className="font-body text-[#D48585] font-semibold hover:underline text-lg" data-testid="contact-email">
                  hello@stashmart.store
                </a>
                <p className="font-body text-sm text-[#78716C] mt-2">
                  For general inquiries, support requests, partnership proposals, or feedback.
                  We aim to respond within 1&ndash;2 business days.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-6 border border-cream-100/50" data-testid="contact-social-card">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-full bg-[#FFF5F5] flex items-center justify-center flex-shrink-0">
                <MessageCircle size={22} className="text-[#C5A880]" />
              </div>
              <div>
                <h2 className="font-heading text-lg text-[#2C2A29] mb-1">Social Media</h2>
                <div className="space-y-2 mt-2">
                  <p className="font-body text-sm text-[#78716C]">
                    <strong className="text-[#2C2A29]">Instagram:</strong>{' '}
                    <a href="https://www.instagram.com/beautystashmart?igsh=MXg0ODFvY2ppeXJmNg==" target="_blank" rel="noopener noreferrer" className="text-[#D48585] hover:underline" data-testid="contact-instagram">@beautystashmart</a>
                  </p>
                  <p className="font-body text-sm text-[#78716C]">
                    <strong className="text-[#2C2A29]">TikTok:</strong>{' '}
                    <span className="text-[#A89F91] italic">Coming soon</span>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-6 border border-cream-100/50" data-testid="contact-phone-card">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-full bg-[#FFF5F5] flex items-center justify-center flex-shrink-0">
                <Phone size={22} className="text-[#D48585]" />
              </div>
              <div>
                <h2 className="font-heading text-lg text-[#2C2A29] mb-1">Support Phone</h2>
                <a href="tel:+628133156950" className="font-body text-[#D48585] font-semibold hover:underline text-lg" data-testid="contact-phone">
                  +62 813-3156-950
                </a>
                <p className="font-body text-sm text-[#78716C] mt-2">
                  Available Monday&ndash;Friday, 10am&ndash;5pm WIB. For faster response, email us.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-6 border border-cream-100/50" data-testid="contact-address-card">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-full bg-[#FFF5F5] flex items-center justify-center flex-shrink-0">
                <MapPin size={22} className="text-[#C5A880]" />
              </div>
              <div>
                <h2 className="font-heading text-lg text-[#2C2A29] mb-1">Office Address</h2>
                <address className="not-italic font-body text-[#2C2A29] text-base leading-relaxed" data-testid="contact-address">
                  Jl. Candi Kalasan III/19<br />
                  Malang, Jawa Timur<br />
                  Indonesia
                </address>
                <p className="font-body text-sm text-[#78716C] mt-2">
                  Mail correspondence and returns should be coordinated via email first.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-[#FFF5F5] rounded-2xl p-6 text-center">
            <p className="font-body text-sm text-[#78716C]">
              {'{'}Beauty{'}'} Stashmart is currently in <strong className="text-[#D48585]">beta</strong>.
              We value your feedback &mdash; every message helps us build a better platform for the beauty community.
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
